// Milestone Category Configuration
// Each category defines its types, fields, examples, and prompts

export const categoryConfig = {
  education: {
    id: 'education',
    name: 'Education',
    emoji: '🎓',
    color: '#3B82F6',
    headerTitle: 'Add Education Milestone',
    step1Title: 'What type of education milestone was this?',
    step1Emoji: '🎓',
    successMessage: 'Your education milestone has been added to your timeline',
    storyLabel: 'What made this educational moment meaningful?',
    storyPlaceholder: 'Tell us about this time... What did you learn? How did it change you?',
    titlePlaceholder: 'e.g., Graduated from UCLA with Bachelor\'s in English',
    titleExamples: [
      'Graduated from...',
      'Started college at...',
      'Got my degree in...'
    ],
    types: [
      { id: 'graduated', emoji: '🎓', title: 'Graduated', desc: 'Completed a degree or program' },
      { id: 'started-school', emoji: '📚', title: 'Started School', desc: 'Began a new school or program' },
      { id: 'academic-honor', emoji: '🏆', title: 'Academic Honor', desc: 'Award, scholarship, or recognition' },
      { id: 'certified', emoji: '📜', title: 'Got Certified', desc: 'Professional certification' },
      { id: 'first-day', emoji: '🎒', title: 'First Day', desc: 'Memorable first day of school' },
      { id: 'other', emoji: '✨', title: 'Something Else', desc: 'I\'ll describe it' }
    ],
    customFields: [
      {
        label: 'School or Institution',
        placeholder: 'e.g., UCLA, Harvard, Community College',
        key: 'school'
      },
      {
        label: 'Degree or Program',
        placeholder: 'e.g., Bachelor\'s in English',
        key: 'degree'
      }
    ]
  },

  career: {
    id: 'career',
    name: 'Career',
    emoji: '💼',
    color: '#556B2F',
    headerTitle: 'Add Career Milestone',
    step1Title: 'What type of career milestone was this?',
    step1Emoji: '💼',
    successMessage: 'Your career milestone has been added to your timeline',
    storyLabel: 'What made this career moment special?',
    storyPlaceholder: 'Tell us more... How did you feel? What led up to this? What did you learn?',
    titlePlaceholder: 'e.g., Started at IBM as Software Engineer',
    titleExamples: [
      'Got my first job at...',
      'Promoted to...',
      'Started my own...'
    ],
    types: [
      { id: 'new-job', emoji: '🎉', title: 'Got a New Job', desc: 'Started a new position' },
      { id: 'promoted', emoji: '📈', title: 'Got Promoted', desc: 'Advanced in my role' },
      { id: 'business', emoji: '🚀', title: 'Started a Business', desc: 'Launched my own venture' },
      { id: 'award', emoji: '🏆', title: 'Won an Award', desc: 'Recognition or achievement' },
      { id: 'retired', emoji: '👋', title: 'Retired', desc: 'End of a career chapter' },
      { id: 'other', emoji: '✨', title: 'Something Else', desc: 'I\'ll describe it' }
    ],
    customFields: [
      {
        label: 'Company or Organization',
        placeholder: 'e.g., IBM, My Own Business',
        key: 'company'
      },
      {
        label: 'Your Role/Title',
        placeholder: 'e.g., Software Engineer',
        key: 'role'
      }
    ]
  },

  family: {
    id: 'family',
    name: 'Family',
    emoji: '👨‍👩‍👧‍👦',
    color: '#EC4899',
    headerTitle: 'Add Family Milestone',
    step1Title: 'What type of family milestone was this?',
    step1Emoji: '👨‍👩‍👧‍👦',
    successMessage: 'Your family milestone has been added to your timeline',
    storyLabel: 'What made this family moment special?',
    storyPlaceholder: 'Share the story... Who was there? How did you feel? What do you want your family to remember?',
    titlePlaceholder: 'e.g., Married Helen at St. Mary\'s Church',
    titleExamples: [
      'Married...',
      'Welcomed our child...',
      'Family reunion in...'
    ],
    types: [
      { id: 'married', emoji: '💒', title: 'Got Married', desc: 'Wedding or commitment ceremony' },
      { id: 'had-child', emoji: '👶', title: 'Had a Child', desc: 'Birth or adoption' },
      { id: 'engaged', emoji: '💍', title: 'Got Engaged', desc: 'Engagement or proposal' },
      { id: 'reunion', emoji: '🎊', title: 'Family Reunion', desc: 'Gathering or celebration' },
      { id: 'loss', emoji: '💔', title: 'Loss of Loved One', desc: 'Passing of family member' },
      { id: 'other', emoji: '✨', title: 'Something Else', desc: 'I\'ll describe it' }
    ],
    customFields: [
      {
        label: 'Family Members Involved',
        placeholder: 'e.g., Helen, Children, Parents',
        key: 'familyMembers'
      },
      {
        label: 'Venue or Setting',
        placeholder: 'e.g., St. Mary\'s Church, Home',
        key: 'venue'
      }
    ]
  },

  home: {
    id: 'home',
    name: 'Home',
    emoji: '🏠',
    color: '#F59E0B',
    headerTitle: 'Add Home Milestone',
    step1Title: 'What type of home milestone was this?',
    step1Emoji: '🏠',
    successMessage: 'Your home milestone has been added to your timeline',
    storyLabel: 'What made this home moment special?',
    storyPlaceholder: 'Tell us about it... What was exciting? What challenges did you face? What memories stand out?',
    titlePlaceholder: 'e.g., Bought our first home on Oak Street',
    titleExamples: [
      'Bought our first home in...',
      'Moved to...',
      'Built our dream house...'
    ],
    types: [
      { id: 'bought', emoji: '🏡', title: 'Bought a Home', desc: 'First home or new purchase' },
      { id: 'moved', emoji: '📦', title: 'Moved', desc: 'Relocated to a new place' },
      { id: 'built', emoji: '🔨', title: 'Built a Home', desc: 'Custom built or major renovation' },
      { id: 'renovation', emoji: '🎨', title: 'Major Renovation', desc: 'Significant home improvement' },
      { id: 'neighborhood', emoji: '🌳', title: 'New Neighborhood', desc: 'Moved to new community' },
      { id: 'other', emoji: '✨', title: 'Something Else', desc: 'I\'ll describe it' }
    ],
    customFields: [
      {
        label: 'Address or Neighborhood',
        placeholder: 'e.g., 123 Oak Street, Sunset District',
        key: 'address'
      },
      {
        label: 'Type of Home',
        placeholder: 'e.g., Victorian, Ranch, Apartment',
        key: 'homeType'
      }
    ]
  },

  travel: {
    id: 'travel',
    name: 'Travel',
    emoji: '✈️',
    color: '#8B5CF6',
    headerTitle: 'Add Travel Milestone',
    step1Title: 'What type of travel milestone was this?',
    step1Emoji: '✈️',
    successMessage: 'Your travel milestone has been added to your timeline',
    storyLabel: 'What made this trip memorable?',
    storyPlaceholder: 'Share the adventure... What did you see? Who were you with? What surprised you? What would you tell your grandchildren about this trip?',
    titlePlaceholder: 'e.g., First trip to Europe with Helen',
    titleExamples: [
      'Visited...',
      'Road trip to...',
      'Family vacation in...'
    ],
    types: [
      { id: 'international', emoji: '🌍', title: 'International Trip', desc: 'Travel to another country' },
      { id: 'road-trip', emoji: '🚗', title: 'Road Trip', desc: 'Driving adventure' },
      { id: 'vacation', emoji: '🏖️', title: 'Vacation', desc: 'Family or personal getaway' },
      { id: 'first-flight', emoji: '✈️', title: 'First Flight', desc: 'First time flying' },
      { id: 'backpacking', emoji: '🎒', title: 'Backpacking', desc: 'Extended travel adventure' },
      { id: 'other', emoji: '✨', title: 'Something Else', desc: 'I\'ll describe it' }
    ],
    customFields: [
      {
        label: 'Destination',
        placeholder: 'e.g., Paris, France',
        key: 'destination'
      },
      {
        label: 'Who did you travel with?',
        placeholder: 'e.g., Helen, Kids, Solo',
        key: 'companions'
      },
      {
        label: 'Trip Duration',
        placeholder: 'e.g., 2 weeks, 3 days',
        key: 'duration',
        fullWidth: true
      }
    ]
  },

  achievement: {
    id: 'achievement',
    name: 'Achievement',
    emoji: '🏆',
    color: '#EF4444',
    headerTitle: 'Add Achievement Milestone',
    step1Title: 'What type of achievement was this?',
    step1Emoji: '🏆',
    successMessage: 'Your achievement has been added to your timeline',
    storyLabel: 'What made this achievement meaningful?',
    storyPlaceholder: 'Tell us about it... What did it take to get here? Who helped you? How did you celebrate? What advice would you give others pursuing the same goal?',
    titlePlaceholder: 'e.g., Ran my first marathon at age 50',
    titleExamples: [
      'Won the...',
      'Completed my first...',
      'Finally achieved...'
    ],
    types: [
      { id: 'award', emoji: '🥇', title: 'Won an Award', desc: 'Competition or recognition' },
      { id: 'athletic', emoji: '🏃', title: 'Athletic Achievement', desc: 'Sports or fitness goal' },
      { id: 'published', emoji: '📝', title: 'Published Work', desc: 'Book, article, or creative work' },
      { id: 'personal-goal', emoji: '🎯', title: 'Personal Goal', desc: 'Long-term goal achieved' },
      { id: 'community', emoji: '🤝', title: 'Community Service', desc: 'Volunteer or charity milestone' },
      { id: 'other', emoji: '✨', title: 'Something Else', desc: 'I\'ll describe it' }
    ],
    customFields: [
      {
        label: 'Type of Achievement',
        placeholder: 'e.g., Marathon, Award, Publication',
        key: 'achievementType'
      },
      {
        label: 'Organization or Event',
        placeholder: 'e.g., Boston Marathon, Local Rotary Club',
        key: 'organization'
      }
    ]
  }
}

export const getCategoryConfig = (categoryId) => {
  return categoryConfig[categoryId] || categoryConfig.career
}
